<template>
  <div>
    <div class="has-margin-bottom-40 has-margin-top-50 has-border-bottom">
      <h2
        class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
      >
        DG Properties
      </h2>
    </div>
    <div class="columns is-multiline">
      <!-- UN Number -->
      <div class="column is-4" v-if="data.dangerous_good_info.un_number">
        <b-field label="UN Number">
          <b-input
            v-model="data.dangerous_good_info.un_number"
            readonly
          ></b-input>
        </b-field>
      </div>

      <!-- Proper Shipping Name-->
      <div
        class="column is-4"
        v-if="data.dangerous_good_info.proper_shipping_name"
      >
        <b-field label="Proper Shipping Name">
          <b-input
            v-model="data.dangerous_good_info.proper_shipping_name"
            readonly
          ></b-input>
        </b-field>
      </div>

      <!-- Chemical Name -->
      <div class="column is-4" v-if="data.chemical_name">
        <b-field label="Chemical Name">
          <b-input v-model="data.chemical_name" readonly></b-input>
        </b-field>
      </div>

      <!-- Control Temperature -->
      <div class="column is-4" v-if="data.control_temperature">
        <b-field label="Controlled Temperature">
          <b-input v-model="data.control_temperature" readonly></b-input>
        </b-field>
      </div>

      <!-- Created At -->
      <div class="column is-4" v-if="data.created_at">
        <b-field label="Created At">
          <b-input v-model="data.created_at" readonly></b-input>
        </b-field>
      </div>

      <!-- Emergency Temperature -->
      <div class="column is-4" v-if="data.emergency_temperature">
        <b-field label="Emergency Temperature">
          <b-input v-model="data.emergency_temperature" readonly></b-input>
        </b-field>
      </div>

      <!-- Empty/Laden Tk -->
      <div class="column is-4" v-if="data.empty_laden_tank">
        <b-field label="Empty/Laden Tk">
          <b-input v-model="data.empty_laden_tank" readonly></b-input>
        </b-field>
      </div>

      <!-- Flash Point -->
      <div class="column is-4" v-if="data.flash_point">
        <b-field label="Flash Point">
          <b-input v-model="data.flash_point" readonly></b-input>
        </b-field>
      </div>

      <!-- denagerous goods id -->
      <div class="column is-4" v-if="data.id">
        <b-field label="Dangerous Good ID">
          <b-input v-model="data.id" readonly></b-input>
        </b-field>
      </div>
      <!-- IMDG Code Segregation Groups -->
      <div class="column is-4" v-if="data.imdg_code_segregation_group">
        <b-field label="IMDG Code Segregation Group">
          <b-input
            v-model="data.imdg_code_segregation_group"
            readonly
          ></b-input>
        </b-field>
      </div>
      <!-- Limited Quantity -->
      <div class="column is-4" v-if="data.limited_quantity">
        <b-field label="Limited Quantity">
          <b-input v-model="data.limited_quantity" readonly></b-input>
        </b-field>
      </div>
      <!-- Marine Pollutant -->
      <div class="column is-4" v-if="data.marine_pollutant">
        <b-field label="Marine Pollutant">
          <b-input v-model="data.marine_pollutant" readonly></b-input>
        </b-field>
      </div>

      <!-- Net Explosive Quantity -->
      <div class="column is-4" v-if="data.net_explosive_quantity">
        <b-field label="Net Explosive Quantity">
          <b-input v-model="data.net_explosive_quantity" readonly></b-input>
        </b-field>
      </div>
      <!-- Sub Risk -->
      <div class="column is-4" v-if="data.sub_risk">
        <b-field label="Sub Risk">
          <b-input v-model="data.sub_risk" readonly></b-input>
        </b-field>
      </div>

      <!-- Temperature Controlled -->
      <div class="column is-4" v-if="data.temperaure_controlled">
        <b-field label="Temperature Controlled">
          <b-input v-model="data.temperaure_controlled" readonly></b-input>
        </b-field>
      </div>

      <!-- Updated At -->
      <div class="column is-4" v-if="data.updated_at">
        <b-field label="Updated At">
          <b-input v-model="data.updated_at" readonly></b-input>
        </b-field>
      </div>

      <!-- dangerous Good Info ID -->
      <div class="column is-4" v-if="data.dangerous_good_info.id">
        <b-field label="Updated At">
          <b-input v-model="data.dangerous_good_info.id" readonly></b-input>
        </b-field>
      </div>

      <!-- Imo Class -->
      <div class="column is-4" v-if="data.dangerous_good_info.imo_class">
        <b-field label="IMO Class">
          <b-input
            v-model="data.dangerous_good_info.imo_class"
            readonly
          ></b-input>
        </b-field>
      </div>

      <!-- Packaging Group -->
      <div class="column is-4" v-if="data.dangerous_good_info.packing_group">
        <b-field label="Packaging Group">
          <b-input
            v-model="data.dangerous_good_info.packing_group"
            readonly
          ></b-input>
        </b-field>
      </div>

      <!-- Storage Space -->
      <div class="column is-4" v-if="data.dangerous_good_info.storage_state">
        <b-field label="Storage Space">
          <b-input
            v-model="data.dangerous_good_info.storage_state"
            readonly
          ></b-input>
        </b-field>
      </div>
    </div>

    <!-- Proper Shipping Name -->

    <div v-for="dg_packaging in dangerousGoodPackaging">
      <dangerous-good-packaging :data="dg_packaging"></dangerous-good-packaging>
    </div>
  </div>
</template>

<script>
import dangerousGoodPackaging from "./DangerousGoodPackaging";

export default {
  name: "dangerousGood",
  components: { dangerousGoodPackaging },
  props: {
    data: Object
  },
  computed: {
    dangerousGoodPackaging: function() {
      return this.data.dangerous_good_packaging;
    }
  }
};
</script>
